module.exports = __webpack_public_path__ + "static/media/Taxfyle.2c40eb27.svg";